export default {
  'new': {
    title: 'Vous savez déjà ce que vous voulez ?',
    description:
      'Un diner entre amis, un anniversaire, ou vous avez déjà votre liste prête, dites-nous tout.',
    button: 'Faire ma liste de course',
  },
  'in-progress': {
    title: 'Votre liste de courses',
    description: 'Reprenez votre liste là où vous en étiez.',
    button: {
      new: 'Nouvelle liste',
      continue: 'Continuer ma liste',
    },
  },
};
